import { DashboardBIService } from "./DashboardBIService";

export const dashboardBiService = new DashboardBIService();